import { useState, useEffect } from 'react';
import { FaTimes } from 'react-icons/fa';
import { zodResolver } from '@hookform/resolvers/zod';
import { systemConfigurationSchema } from '../../../../schemas/systemConfiguration.schema';
import { useForm } from 'react-hook-form';
import { toast } from 'react-hot-toast';
import { MODE } from '../../../../interaces/mode.interface';
import { colorSystemConfigurationsApi } from '../../api/colorSystemConfigurations.api';
import { fornameTheme } from '../../../../services/helpers';
import {
  TOAST_ERROR_IDS,
  TOAST_INFO_IDS,
  TOAST_SUCCESS_IDS,
} from '../../../../interaces/toast.ids.interface';
import { streamData } from '../../../../services/helpers';
import { setSystemColors, setPrimaryColor, setSecondaryColor } from '../../../../services/helpers';
import { COLOR_PALETTE } from '../../../../interaces/system-configuration.interface';
import { updateDataWhenCreate, updateDataWhenUpdate } from '../../../../services/helpers';
import styles from "../../styles/styles.module.css"
function ModalColorsSystemConfigurations({
  setEntities = () => {},
  setOpen = () => {},
  onClose,
  onSaved,
  model = null,
  mode = MODE.CREATE,
  currentPrimaryColor = null,
  currentSecondaryColor = null,
}) {
  const {
    register,
    watch,
    setValue,
    handleSubmit,
    control,
    formState: { errors, isDirty },
    reset,
  } = useForm({
    resolver: zodResolver(systemConfigurationSchema),
  });

  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (model && mode == MODE.UPDATE) {
      reset({
        status: model.status ?? false,
        primaryColor: model.primaryColor ?? '',
        secondaryColor: model.secondaryColor ?? '',
        nameTheme: model.nameTheme ?? '',
      });

      if (model.primaryColor && model.secondaryColor) {
        setSystemColors(model.primaryColor, model.secondaryColor);
      }
    } else {
      reset({
        status: false,
        primaryColor: '',
        secondaryColor: '',
        nameTheme: '',
      });
    }
  }, [model, model]);

  const [updateAndChange, setUpdateAndChange] = useState(false);
  const [createAndChange, setCreateAndChange] = useState(false);

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      if (createAndChange == true) {
        data.status = true;
      }
      if (updateAndChange == true) {
        data.status = true;
      }

      streamData(data);
      if (mode == MODE.CREATE) {
        const response = await colorSystemConfigurationsApi.create(data);
        if (
          response &&
          response.primaryColor &&
          response.secondaryColor &&
          response.status == true
        ) {
          setSystemColors(response.primaryColor, response.secondaryColor);
          setEntities((prev) =>
            prev.map((item) => (item.status === true ? { ...item, status: false } : item))
          );
        } else {
          setSystemColors(currentPrimaryColor, currentSecondaryColor);
        }
        updateDataWhenCreate(setEntities, response);
      } else {
        if (
          model.status == data.status &&
          model.primaryColor == data.primaryColor &&
          model.secondaryColor == data.secondaryColor &&
          model.nameTheme == data.nameTheme
        ) {
          toast(TOAST_INFO_IDS.NO_DATA_TO_UPDATE, {
            icon: 'ℹ️',
            id: TOAST_INFO_IDS.NO_DATA_TO_UPDATE,
          });

          return;
        }
        const response = await colorSystemConfigurationsApi.update(model.id, data);
        if (
          response &&
          response.primaryColor &&
          response.secondaryColor &&
          response.status == true
        ) {
          setSystemColors(response.primaryColor, response.secondaryColor);
        } else {
          //quitamos los colores
          setSystemColors(currentPrimaryColor, currentSecondaryColor);
        }
        updateDataWhenUpdate(setEntities, response);
      }
      toast.success(
        mode == MODE.CREATE
          ? TOAST_SUCCESS_IDS.RECORD_SAVED_SUCCESSFULLY
          : TOAST_SUCCESS_IDS.RECORD_UPDATED_SUCCESSFULLY,
        { id: TOAST_SUCCESS_IDS.RECORD_SAVED_SUCCESSFULLY }
      );
      if (onSaved) onSaved();
      setOpen(false);
    } catch (error) {
      toast.error(
        (error.message && error.message != 'Error'
          ? error.message
          : TOAST_ERROR_IDS.ERROR_PERFORMING_THIS_ACTION) ||
          TOAST_ERROR_IDS.ERROR_PERFORMING_THIS_ACTION,
        { id: TOAST_ERROR_IDS.TWO }
      );
    } finally {
      setLoading(false);
    }
  };

  const viewColorChange = (number) => {
    const primaryColor = watch('primaryColor');
    const secondaryColor = watch('secondaryColor');
    if (number == 'primaryColor') {
      setPrimaryColor(primaryColor);
    }
    if (number == 'secondaryColor') {
      setSecondaryColor(secondaryColor);
    }
  };

  const [whereChanges, setWhereChanges] = useState(false);
  useEffect(() => {
    if (isDirty) {
      setWhereChanges(true);
    } else {
      setWhereChanges(false);
    }
  }, [isDirty]);

  return (
    <div className="modal-overlay">
      <div className="modal-content modal-sizes">
        {/* Header */}
        <div className="modal-header">
          <h2 className="modal-title">
            {model ? 'Editar configuración' : 'Nueva configuración'}
          </h2>
          <button type="button" onClick={onClose} className="modal-close-btn">
            <FaTimes />
          </button>
        </div>

        <div className="modal-body">
          <div className={styles.divTextStart}>
            <p className={styles.textStart1}>
              Al elegir un nuevo color primario o secundario se mostrará la vista previa
            </p>
            <p className={styles.textStart2}>¡Evita elegir colores claro!</p>
          </div>

          <form className="modal-form" onSubmit={handleSubmit(onSubmit)}>
            <div className="modal-div-column-one">
              <label className="label-base">
                Nombre del tema<p className="modal-input-required">*</p>
              </label>
              <input
                type="text"
                maxLength={100}
                {...register('nameTheme', {
                  onChange: (e) => {
                    fornameTheme(e);
                  },
                })}
                placeholder="Nombre del tema"
                className="input-base resize-none"
              />
              {errors.nameTheme && (
                <span className="error-text">{errors.nameTheme.message}</span>
              )}
            </div>

            <div className={styles.mainDivColorPalet}>
              {/* PALETA */}
              <div className={styles.secondaryDivPalet}>
              <label className="label-base">
                  Color primario
                  <p className="modal-input-required">*</p>
                </label>

                <div className={styles.thirdDivColorPalet}>
                  <label className={styles.labelTextColor}>Selecciona un color</label>

                  <div className={styles.divPalet}>
                    {COLOR_PALETTE.map((color) => {
                      const selected = watch('primaryColor') === color;

                      return (
                        <button
                          key={color}
                          type="button"
                          onClick={() => {
                            setValue('primaryColor', color, {
                              shouldDirty: true,
                              shouldValidate: true,
                            });

                            setPrimaryColor(color);
                          }}

                          className={`${selected} ? ${styles.buttonSelectedColor} : ${styles.buttonNoSelectedColor} `}

                          style={{
                            backgroundColor: color,
                          }}
                          title={color}
                        />
                      );
                    })}
                  </div>
                </div>

                {errors.primaryColor && (
                  <span className="error-text">{errors.primaryColor.message}</span>
                )}
              </div>

              {/* PERSONALIZADO */}
              <div className={styles.mainDivPersonalizeColor}>
                <label className={styles.labelPersonalizeColor}>Personalizar color</label>

                <div className={styles.secondaryDivPersonalizeColor}>
                  <input
                    type="color"
                    {...register('primaryColor', {
                      onChange: () => {
                        viewColorChange('primaryColor');
                      },
                    })}
                    className={styles.inputPersonalizeColor}
                  />

                  {/* Información */}
                  <div className={styles.divInformationPersonalizeColor}>
                    <span className={styles.spanInformationPersonalizeColor}>
                      {watch('primaryColor') || '#000000'}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div className={styles.mainDivColorPalet}>
              <div className={styles.secondaryDivPalet}>
                <label className="label-base">
                  Color secundario
                  <p className="modal-input-required">*</p>
                </label>

                <div className={styles.thirdDivColorPalet}>
                  <label className={styles.labelTextColor}>Selecciona un color</label>

                  <div className={styles.divPalet}>
                    {COLOR_PALETTE.map((color) => {
                      const selected = watch('secondaryColor') === color;
                      return (
                        <button
                          key={color}
                          type="button"
                          onClick={() => {
                            setValue('secondaryColor', color, {
                              shouldDirty: true,
                              shouldValidate: true,
                            });

                            setSecondaryColor(color);
                          }}
                          className={`${selected} ? ${styles.buttonSelectedColor} : ${styles.buttonNoSelectedColor} `}
                          style={{
                            backgroundColor: color,
                          }}
                          title={color}
                        />
                      );
                    })}
                  </div>
                </div>
                {errors.secondaryColor && (
                  <span className="error-text">{errors.secondaryColor.message}</span>
                )}
              </div>
              <div className={styles.mainDivPersonalizeColor}>
                <label className={styles.labelPersonalizeColor}>Personalizar color</label>
                <div className={styles.secondaryDivPersonalizeColor}>
                  <input
                    type="color"
                    {...register('secondaryColor', {
                      onChange: () => {
                        viewColorChange('secondaryColor');
                      },
                    })}
                    className={styles.inputPersonalizeColor}
                  />
                  {/* Información */}
                  <div className={styles.divInformationPersonalizeColor}>
                    <span className={styles.spanInformationPersonalizeColor}>
                      {watch('secondaryColor') || '#000000'}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div className={`modal-footer  ${styles.divFooter}`}>
              <button type="button" onClick={onClose} className="btn-cancel">
                Cancelar
              </button>

              <button
                type="submit"
                disabled={loading == true || (!whereChanges && mode == MODE.UPDATE) ? true : false}
                className="btn-primary"
              >
                {loading ? 'Guardando...' : mode == MODE.CREATE ? 'Agregar ' : 'Actualizar'}
              </button>
              {(Boolean(mode == MODE.CREATE) ||
                Boolean(mode == MODE.UPDATE && model && model.status !== true)) && (
                <button
                  type="submit"
                  onClick={(data) => {
                    mode == MODE.CREATE ? setCreateAndChange(true) : setUpdateAndChange(true);
                  }}
                  disabled={
                    loading == true || (!whereChanges && mode == MODE.UPDATE) ? true : false
                  }
                  className={`btn-primary ${styles.btnSaveAndChange}`}
                >
                  {loading
                    ? 'Guardando...'
                    : mode == MODE.CREATE
                      ? 'Agregar y cambiar'
                      : 'Actualizar y cambiar'}
                </button>
              )}
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default ModalColorsSystemConfigurations;
